import locale from "localization";
import styles from "./shift-details-stock-inventory.module.scss";
import { prettifyProductCode } from "utils/pretty.utils";
import ProductCode from "enums/product-code";
import { Title } from "components/commons";
import FuelSummary from "./shift-details-fuel-product-summary";
import { sortBy } from "lodash";

const ShiftDetailsFuelSales = ({
  shift,
  isShiftEndedCompletely,
}) => {
  const diesel = sortBy(shift?.transactionItem.dieselTransactionItem, "metadata");

  const gas91 = sortBy(shift?.transactionItem.gas91TransactionItem, "metadata");

  const gas95 = sortBy(shift?.transactionItem.gas95TransactionItem, "metadata");

  const gas97 = sortBy(shift?.transactionItem.gas97TransactionItem, "metadata");

  return (
    <>
      <Title small black>
        {locale.fuelSales}
      </Title>
      <div className={styles.tableContainer}>
        <div className={styles.fuelSalesTable}>
          <FuelSummary
            shift={shift}
            isShiftEndedCompletely={isShiftEndedCompletely}
            data={diesel}
            name={prettifyProductCode(ProductCode.DIESEL)}
            sku={ProductCode.DIESEL}
            transactions={shift.transactionItem.dieselTransactions}
          />
          <div className={styles.spacer20} />
          <FuelSummary
            shift={shift}
            isShiftEndedCompletely={isShiftEndedCompletely}
            data={gas91}
            name={prettifyProductCode(ProductCode.GAS91)}
            sku={ProductCode.GAS91}
            transactions={shift.transactionItem.gas91Transactions}
          />
          <div className={styles.spacer20} />
          <FuelSummary
            shift={shift}
            isShiftEndedCompletely={isShiftEndedCompletely}
            data={gas95}
            name={prettifyProductCode(ProductCode.GAS95)}
            sku={ProductCode.GAS95}
            transactions={shift.transactionItem.gas95Transactions}
          />
          <div className={styles.spacer20} />
          <FuelSummary
            shift={shift}
            isShiftEndedCompletely={isShiftEndedCompletely}
            data={gas97}
            name={prettifyProductCode(ProductCode.GAS97)}
            sku={ProductCode.GAS97}
            transactions={shift.transactionItem.gas97Transactions}
          />
        </div>
      </div>
      <div className={styles.spacer10} />
    </>
  );
};

export default ShiftDetailsFuelSales;
